import api from "../../../../app/api";
import {ROLES} from "../../../../app/constants";
import {Options} from "../../../../common";
import {UserFormItem, UserListItem, UserOptions} from "../userApi";
import {InviteFormProps} from "./useInviteForm";

export interface InviteForm {
  email: string;
  role: ROLES;
  permissions: string[];
}


export type InviteOptions = Options<"role" | "permissions">;

export async function inviteService() {
  return api.getService<InviteForm, {}, InviteOptions>("invite", {
    itemExporter: item => ({ InviteForm: item }),
  });
}

export async function inviteOptions() {
  return api.get(
    '/users/options?component=invite'
  );
}

export async function invite(item: InviteForm) {
  return api.post(
    '/users/invite',
    {
      InviteForm: item,
    }
  );
}